import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { IntercomEffects } from '@core/intercom/effects/intercom.effects';

@NgModule({
  declarations: [],
  imports: [EffectsModule.forFeature([IntercomEffects])],
})
export class IntercomModule {}
